import CardWrapper, { wrapperWidth } from "core/components/CardWrapper";
import Actions from "core/components/FormDefaultActions";
import FormInput from "core/components/FormInput";
import { Form } from "reactstrap";
import Spinner from "core/components/Spinner";

const BroadcastData = ({ broadcast, onUpdate, recipients }) => {
    const updateBroadcast = newValue =>
        onUpdate({
            ...broadcast,
            ...newValue
        });
    return (
        <div>
            <h2>Destinatarios</h2>
            <p>Solamente a miembros mensuales y administradores</p>
            <ul>
                {recipients.map(recipient => (
                    <li key={recipient.id}>
                        {recipient.name} ({recipient.email})
                    </li>
                ))}
            </ul>
            <div>
                <FormInput
                    id="subject"
                    label="Asunto"
                    value={broadcast.subject || ""}
                    onChange={e =>
                        updateBroadcast({
                            subject: e.target.value
                        })
                    }
                    mandatory
                />
            </div>
            <div>
                <FormInput
                    id="content"
                    label="Contenido"
                    value={broadcast.content || ""}
                    onChange={e =>
                        updateBroadcast({
                            content: e.target.value
                        })
                    }
                    mandatory
                    type="textarea"
                    rows={4}
                />
            </div>
        </div>
    );
};

const BroadcastForm = ({ broadcast, onSubmit, onCancel, onBroadcastUpdated, submitting, recipients, loading }) => {
    const handleSubmit = e => {
        e.preventDefault();
        onSubmit();
    };

    const title = "Crear email masivo";

    return (
        <CardWrapper title={title} width={wrapperWidth.s}>
            <Spinner show={loading} size="fa-3x" />
            {!loading &&
                <Form onSubmit={handleSubmit}>
                    <BroadcastData
                        broadcast={broadcast}
                        recipients={recipients}
                        onUpdate={onBroadcastUpdated}
                    />
                    <Actions
                        onSubmit={handleSubmit}
                        onCancel={onCancel}
                        submitting={submitting}
                        submitText="Enviar"
                        submittingText="Enviando..."
                    />
                </Form>}
        </CardWrapper>
    );
};

export default BroadcastForm;
